import { render } from "./EmployeeAvatar.vue?vue&type=template&id=b3de4a46&scoped=true"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=js"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=js"

import "./EmployeeAvatar.vue?vue&type=style&index=0&id=b3de4a46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3de4a46"]])

export default __exports__